import React, { useState, useEffect } from 'react';
import { styled } from '@mui/system';
import Text from '../../../../components/Text.js';
import Switch from '../../../../components/Switch.js';
import SearchBar from '../../../../components/SearchBar.js';
import MemberPremiumBlock from './../components/MemberPremiumBlock.js';
import SectionLine from './../components/SectionLine.js';
import i18n from '../../../../localization/i18n.js';
import tokens from '../../../../localization/tokens.js';
const Block = styled('div')({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  paddingRight: 10
});
const styles = {
  currentTransactionsHeader: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 20
  },
  switch: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-end"
  }
};

/**
 *
 * @param {*} value
 * @param {*} users
 * @param {*} setFilteredUsers
 */
const _searchInput = (value, users, setFilteredUsers) => {
  if (!value) {
    setFilteredUsers(users);
  } else {
    // Perform filtering on the original users array
    const filteredUsers = users.filter(user => {
      const userName = `${user.meta.firstname.toLowerCase()} ${user.meta.lastname.toLowerCase()}`;
      return userName.includes(value.toLowerCase());
    });
    setFilteredUsers(filteredUsers);
  }
};

/**
 * @param users
 * @param accountClasses
 * @param divisions
 * @param blockMemberDetails
 * @param isMemberInvoice
 * @param transaction
 * @param isPrivateLabel
 * @returns {JSX.Element|null}
 * @constructor
 */
const CurrentTransactions = ({
  users,
  accountClasses,
  divisions,
  blockMemberDetails,
  isMemberInvoice,
  transaction,
  isPrivateLabel
}) => {
  const [showCurrentTransactions, toggleCurrentTransactions] = useState(true);
  const [filteredUsers, setFilteredUsers] = useState([]);
  useEffect(() => {
    /*
     * if the invoice display is switched to a divisional view, we need to check to see if the users prop has changed as we filter the users array in the parent component.
     * Otherwise, we will always be using the initially passed in users array which contains all of the users.
     */
    setFilteredUsers(users);
  }, [users]);
  if (blockMemberDetails) {
    return null;
  }
  if (isMemberInvoice && transaction) {
    return /*#__PURE__*/React.createElement(MemberPremiumBlock, {
      key: 1,
      transaction: transaction,
      isMemberInvoice: isMemberInvoice
    });
  }
  return /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement(SectionLine, null), /*#__PURE__*/React.createElement("div", {
    style: styles.currentTransactionsHeader
  }, /*#__PURE__*/React.createElement(Text, {
    largest: true,
    bold: true
  }, i18n.t(tokens.labels.invoices.currentTransactions)), /*#__PURE__*/React.createElement("div", {
    style: styles.switch
  }, /*#__PURE__*/React.createElement(Text, {
    small: true,
    light: true,
    customStyle: {
      marginBottom: 3,
      marginRight: 10
    }
  }, i18n.t(tokens.labels.invoices.showDetailedCurrentTransactions)), /*#__PURE__*/React.createElement(Switch, {
    onChange: toggleCurrentTransactions,
    checked: showCurrentTransactions
  }))), showCurrentTransactions ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SearchBar
  // searching is done onChange, but we need to pass a function here or we get an error
  , {
    search: e => null,
    onChange: e => _searchInput(e.target.value, users, setFilteredUsers),
    customStyle: {
      alignSelf: 'flex-start',
      backgroundColor: '#FFF',
      margin: '8px 0 0'
    }
  }), filteredUsers && filteredUsers.map(user => /*#__PURE__*/React.createElement(MemberPremiumBlock, {
    key: `${user.meta.birthdate} ${user.meta.firstname} ${user.meta.salary} ${user.meta.lastname}`,
    transaction: user,
    classDescription: accountClasses[user.meta.classID]?.description,
    divisionDescription: divisions[user.meta.divisionID]?.description,
    isPrivateLabel: isPrivateLabel
  }))) : null);
};
export default CurrentTransactions;